export const CARD_WIDTH = "16.25rem"
export const CARD_HEIGHT = "8rem"
